<nz-space nzDirection="vertical" nzSize="large" style="width:100%">
  <nz-space-item>
    <signature-pad [options]="signaturePadOptions" id="signatureCanvas"></signature-pad>
  </nz-space-item>
  <nz-space-item>
    <nz-space>
      <nz-space-item *ngIf="globals.showSignaturePadTermsAndCondition">
        <label nz-checkbox [(ngModel)]="acceptTerms" [ngModelOptions]="{standalone: true}"></label>
        &nbsp;&nbsp;<a [href]="globals.signaturePadTermsAndConditionLink" target="_blank">{{ globals.signaturePadTermsAndConditionText }}</a>
      </nz-space-item>
      <nz-space-item>
        <button nz-button nzType="primary" (click)="drawComplete()" [nzLoading]="isLoading">
          <i nz-icon nzTheme="outline" nzType="upload"></i>
          {{'Submit' | locale}}
        </button>
      </nz-space-item>
      <nz-space-item>
        <button nz-button (click)="clear()">
          <i nz-icon nzTheme="outline" nzType="clear"></i>
          {{'Clear' | locale}}
        </button>
      </nz-space-item>
    </nz-space>
  </nz-space-item>
</nz-space>
